<template>
  <help-dialog title="Create Entity">
    <template #default>
      <h3><span class="bg-yellow-lighten-4">Create Entity</span></h3>
      There are three different ways you can create an Entity:<br /><br />
      <ul>
        <li class="mb-3">
          <strong>Generate from Workflow with AI</strong><br />
          Uses AI to analyze your Workflow’s Events, Commands, and Read Models, then automatically
          generates multiple Entity tables. This is ideal if you want a quick, AI-driven starting point.
        </li>
        <li class="mb-3">
          <strong>Generate from Description with AI</strong><br />
          Uses AI to create one or more Entity tables based on a description you provide.The description can be
          a database schema in any format or plain text. Choose this option when you have specific requirements in mind.
        </li>
        <li>
          <strong>Start Manually</strong><br />
          Creates a new Entity table with a single placeholder field so you can start
          defining it by hand. Rename the field and add more as needed.
        </li>
      </ul>
      <br />
      Note: When using AI, information about your workflow will be shared with the selected AI provider.
      <br /><br />
      <p v-if="brand.links.generateWithAi" class="text-grey-darken-4">
        For more information,
        <a
          :href="brand.links.generateWithAi"
          target="_blank"
          class="text-blue-accent-4"
        >
          click here
        </a>.
      </p>
    </template>
  </help-dialog>
</template>

<script setup>
import HelpDialog from '@/components/HelpDialog.vue'
import { useBrand } from '@/composables/useBrand'

const brand = useBrand()
</script>
